<script>
import { mapGetters } from "vuex";

export default {
  name: "AppAuthenticated",
  computed: {
    ...mapGetters("customers", ["customer"]),
  },
  render() {
    if (!this.customer) {
      return null;
    }

    return this.$scopedSlots.default({ customer: this.customer });
  },
};
</script>
